export enum DomainValueType {
  DATE_TIME = 'A',
  BOOLEAN = 'B',
  SHORT_DESCRIPTION = 'C',
  DESCRIPTION = 'D',
  SELECT_RESULT = 'E',
  TITLE_WITH_MANDATORY_SIZE = 'H',
  TITLE = 'T',
  IMAGE = 'I',
  CALCULATION = 'L',
  MULTI_SELECTION = 'M',
  DOMAIN = 'O',
  SELECT_LONG_RESULT = 'F',
  LONG_DESCRIPTION = 'P',
  SELECT_SIMPLE = 'S',
  SELECT = 'R',
  UNIQUE_SELECT = 'U',
  VALUE = 'V',
  TEXT = 'X',
  LOCATOR = 'Z',
}